import { API_METHODS } from './api.enums';
import { apiAction } from './utils.actions';
import type {
    ExternalJobImportPreview,
    ExternalJobImportResult,
} from '../../types/externalJobImport.types';

export type { ExternalJobImportPreview, ExternalJobImportResult };

export const getExternalJobImportPreview = (
    { userid }: { userid: number },
) => apiAction<ExternalJobImportPreview>({
    url: `/api/import/external-jobs/${userid}/preview`,
    method: API_METHODS.GET,
});

export const importExternalJobs = (
    { userid, amount }: { userid: number, amount?: number },
) => {
    if (amount === undefined) {
        return apiAction<ExternalJobImportResult>({
            url: `/api/import/external-jobs/${userid}`,
            method: API_METHODS.GET,
        });
    }

    return apiAction<ExternalJobImportResult>({
        url: `/api/import/external-jobs/${userid}`,
        method: API_METHODS.POST,
        payload: { amount },
    });
};
